"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _IllegalArgumentException = _interopRequireDefault(require("../../../../../java/lang/IllegalArgumentException"));

var _AbstractNode = _interopRequireDefault(require("./AbstractNode"));

var _Comparable = _interopRequireDefault(require("../../../../../java/lang/Comparable"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BoundablePair =
/*#__PURE__*/
function () {
  function BoundablePair() {
    _classCallCheck(this, BoundablePair);

    BoundablePair.constructor_.apply(this, arguments);
  }

  _createClass(BoundablePair, [{
    key: "expandToQueue",
    value: function expandToQueue(priQ, minDistance) {
      var isComp1 = BoundablePair.isComposite(this._boundable1);
      var isComp2 = BoundablePair.isComposite(this._boundable2);

      if (isComp1 && isComp2) {
        if (BoundablePair.area(this._boundable1) > BoundablePair.area(this._boundable2)) {
          this.expand(this._boundable1, this._boundable2, priQ, minDistance);
          return null;
        } else {
          this.expand(this._boundable2, this._boundable1, priQ, minDistance);
          return null;
        }
      } else if (isComp1) {
        this.expand(this._boundable1, this._boundable2, priQ, minDistance);
        return null;
      } else if (isComp2) {
        this.expand(this._boundable2, this._boundable1, priQ, minDistance);
        return null;
      }

      throw new _IllegalArgumentException.default("neither boundable is composite");
    }
  }, {
    key: "isLeaves",
    value: function isLeaves() {
      return !(BoundablePair.isComposite(this._boundable1) || BoundablePair.isComposite(this._boundable2));
    }
  }, {
    key: "compareTo",
    value: function compareTo(o) {
      var nd = o;
      if (this._distance < nd._distance) return -1;
      if (this._distance > nd._distance) return 1;
      return 0;
    }
  }, {
    key: "expand",
    value: function expand(bndComposite, bndOther, priQ, minDistance) {
      var children = bndComposite.getChildBoundables();

      for (var i = children.iterator(); i.hasNext();) {
        var child = i.next();
        var bp = new BoundablePair(child, bndOther, this._itemDistance);

        if (bp.getDistance() < minDistance) {
          priQ.add(bp);
        }
      }
    }
  }, {
    key: "getBoundable",
    value: function getBoundable(i) {
      if (i === 0) return this._boundable1;
      return this._boundable2;
    }
  }, {
    key: "getDistance",
    value: function getDistance() {
      return this._distance;
    }
  }, {
    key: "distance",
    value: function distance() {
      if (this.isLeaves()) {
        return this._itemDistance.distance(this._boundable1, this._boundable2);
      }

      return this._boundable1.getBounds().distance(this._boundable2.getBounds());
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return BoundablePair;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Comparable.default];
    }
  }], [{
    key: "area",
    value: function area(b) {
      return b.getBounds().getArea();
    }
  }, {
    key: "isComposite",
    value: function isComposite(item) {
      return item instanceof _AbstractNode.default;
    }
  }]);

  return BoundablePair;
}();

exports.default = BoundablePair;

BoundablePair.constructor_ = function () {
  this._boundable1 = null;
  this._boundable2 = null;
  this._distance = null;
  this._itemDistance = null;
  var boundable1 = arguments[0],
      boundable2 = arguments[1],
      itemDistance = arguments[2];
  this._boundable1 = boundable1;
  this._boundable2 = boundable2;
  this._itemDistance = itemDistance;
  this._distance = this.distance();
};